import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Box,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Grid,
  Paper as MuiPaper,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useFormContext } from "react-hook-form";

import useOttPlan from "../../../../hooks/useOttPlan";
import DeletePlanGroupModal from "./DeletePlanGroupModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import EditDelete from "../../../../components/EditDelete";
import MapPlanModal from "./MapPlanModal";
import useWindowDimensions from "../../../../utils/windowDimensions";
import useMainContentDimensions from "../../../../utils/mainContentDimensions";

const Paper = styled(MuiPaper)(spacing);

const AssignOttPlans = ({ assignedToId }) => {
  const { width: mainContentWidth } = useMainContentDimensions();
  const { height } = useWindowDimensions();
  const { openDialog } = useDialog();
  const currentPayload = {
    filters: [
      {
        attributeName: "assignedTo",
        fieldName: "tenantId",
        fieldValue: assignedToId,
        op: "eq",
        isJoin: true,
        dataType: "long",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };
  const [payload, setPayload] = useState(currentPayload);
  const { isLoadingOttPlans, getAllOttPlans, ottPlans, paging } = useOttPlan();

  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  console.log(watch("ottPlans"), "ottplanssss");

  const fetchData = async () => {
    await getAllOttPlans(payload);
  };

  const deleteItemClick = async (planSharingId) => {
    return openDialog(
      "delete_plan_group",
      "Delete Plan Group",
      <DeletePlanGroupModal
        key={getTimeStamp()}
        planSharingId={planSharingId}
        refreshPage={fetchData}
      />,
    );
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete
            menus={["delete", "edit"]}
            rowClick={onClick}
            deleteItemClick={() => deleteItemClick(params.id)}
            editPage={() => null}
          />
        );
      },
    },
    {
      field: "planName",
      headerName: "Plan Name",
      type: "string",
      width: 300,
    },
    {
      field: "planCode",
      headerName: "Plan Code",
      type: "string",
      width: 300,
    },
    {
      field: "interval",
      headerName: "Time Unit",
      type: "string",
      width: 300,
    },
    {
      field: "intervalUnit",
      headerName: "Time Unit Type",
      type: "string",
      width: 300,
    },
  ];
  const onPageChange = (page) => {
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };
  const [selectedRows, setSelectedRows] = useState([]);
  useEffect(() => {
    const initial = watch("ottPlans") || [];
    setSelectedRows(initial);
  }, []);

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <DataGrid
          columns={columns}
          rows={ottPlans}
          rowCount={paging.totalNumberOfRecords}
          getRowId={(row) => row["ottPlanId"]}
          loading={isLoadingOttPlans}
          rowsPerPageOptions={[5]}
          pagination
          page={paging.pageNumber}
          pageSize={paging.pageSize}
          paginationMode="server"
          onPageChange={(page) => onPageChange(page)}
          onPageSizeChange={(pageSize) => onPageChange(pageSize)}
          checkboxSelection
          sortingMode="server"
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(newSelection) => {
            setSelectedRows(newSelection);
            setValue("ottPlans", newSelection);
          }}
        />
      </CardContent>
    </Card>
  );
};

export default AssignOttPlans;
